// src/routes/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../services/useAuthStore";

/**
 * ProtectedRoute - Componente de rota protegida
 *
 * Props:
 * - children: Componente filho a ser renderizado
 * - requireWorkspace: Se true (default), exige workspace selecionado
 *
 * Comportamento:
 * - Se nao autenticado: redireciona para /login
 * - Se autenticado mas sem workspace (e requireWorkspace=true): redireciona para /select-workspace
 * - Se autenticado e com workspace: renderiza children
 */
const ProtectedRoute = ({ children, requireWorkspace = true }) => {
  const location = useLocation();

  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const workspace = useAuthStore((s) => s.workspace);
  const workspaces = useAuthStore((s) => s.workspaces);

  // Se nao autenticado, redirecionar para login
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  // Se requireWorkspace e nao tem workspace selecionado
  if (requireWorkspace && !workspace) {
    // Se tem multiplos workspaces, ir para seletor
    if (workspaces && workspaces.length > 1) {
      return <Navigate to="/select-workspace" replace />;
    }
    // Se tem apenas 1 workspace, ele sera selecionado automaticamente no initAuthFromMe
    // Enquanto isso, nao renderizar nada (evita flash)
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
